import { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";

export const TestDashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("TestDashboard: Starting fetch...");
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/portfolio`);
        console.log("TestDashboard: Response status:", response.status);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        console.log("TestDashboard: Data received:", result);
        setData(result);
      } catch (err) {
        console.error("TestDashboard: Error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="p-6" data-testid="test-dashboard-loading">
        <h1>Loading Test Dashboard...</h1>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6" data-testid="test-dashboard-error">
        <h1>Error in Test Dashboard</h1>
        <p>Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="p-6" data-testid="test-dashboard">
      <h1 className="text-2xl font-bold mb-4">Test Dashboard</h1>
      <div className="bg-gray-100 p-4 rounded">
        <h2 className="text-lg font-semibold">Portfolio Data:</h2>
        <pre>{JSON.stringify(data, null, 2)}</pre>
      </div>
    </div>
  );
};

export default TestDashboard;